(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alisened-room-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('alisened-room-products')) {
  customElements.define('alisened-room-products', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      const tabs = [...this.querySelectorAll('.alrt__tab')];
      const panels = [...this.querySelectorAll('.alrt__panel')];
      const arrows = [...this.querySelectorAll('[data-alrt-direction]')];
      if (!tabs.length) return;
      let active = 0;
      const update = () => {
        const track = panels[active].querySelector('.alrt__track');
        arrows.forEach(button => {
          button.disabled = Number(button.dataset.alrtDirection) < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= track.scrollWidth-track.clientWidth-2;
          button.setAttribute('aria-controls', panels[active].id);
        });
      };
      const select = (index, focus = false) => {
        active = index;
        tabs.forEach((tab, i) => {
          tab.setAttribute('role','tab');
          tab.setAttribute('aria-controls',panels[i].id);
          tab.setAttribute('aria-selected',String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].setAttribute('role','tabpanel');
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
        update();
      };
      this.querySelector('.alrt__tabs').setAttribute('role','tablist');
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', event => {event.preventDefault();select(i);},options);
        tab.addEventListener('keydown', event => {
          let index;
          if(event.key === 'ArrowRight') index = (i+1)%tabs.length;
          if(event.key === 'ArrowLeft') index = (i-1+tabs.length)%tabs.length;
          if(event.key === 'Home') index = 0;
          if(event.key === 'End') index = tabs.length-1;
          if(index !== undefined) {event.preventDefault();select(index,true);}
        },options);
      });
      panels.forEach(panel => panel.querySelector('.alrt__track').addEventListener('scroll',update,{...options,passive:true}));
      arrows.forEach(button => button.addEventListener('click',() => {
        const track = panels[active].querySelector('.alrt__track');
        const card = track.querySelector('.alrt__item');
        if(!card) return;
        track.scrollBy({left:(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap))*Number(button.dataset.alrtDirection),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      },options));
      this.addEventListener('shopify:block:select',event => {
        const index = panels.findIndex(panel => panel === event.target || panel.contains(event.target));
        if(index >= 0) select(index);
      },options);
      this.observer = new ResizeObserver(update);
      panels.forEach(panel => this.observer.observe(panel.querySelector('.alrt__track')));
      select(0);
      this.setAttribute('data-ready','');
    }
    disconnectedCallback() {this.controller?.abort();this.controller=null;this.observer?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alisened-social-videos"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('alisened-ugc')){
customElements.define('alisened-ugc',class extends HTMLElement{
connectedCallback(){
if(this.controller)return;
this.controller=new AbortController();
const options={signal:this.controller.signal};
const cards=[...this.querySelectorAll('.asv__card')];
const reset=card=>{
const video=card.querySelector('video');
if(video){video.pause();video.removeAttribute('src');video.querySelectorAll('source').forEach(source=>source.removeAttribute('src'));video.load();video.remove();}
const button=card.querySelector('[data-play]');
if(button){button.hidden=false;button.setAttribute('aria-pressed','false');}
};
this.resetAll=()=>cards.forEach(reset);
this.addEventListener('click',async event=>{
const button=event.target.closest('[data-play]');
if(!button)return;
const card=button.closest('.asv__card');
const media=card.querySelector('.asv__media');
const status=card.querySelector('.asv__error');
if(!media.dataset.videoSrc)return;
cards.forEach(other=>{if(other!==card)reset(other);});
let video=media.querySelector('video');
if(!video){
video=document.createElement('video');
video.controls=true;video.playsInline=true;video.preload='none';
video.setAttribute('aria-label',button.getAttribute('aria-label'));
video.src=media.dataset.videoSrc;
media.append(video);
video.addEventListener('playing',()=>{button.hidden=true;button.setAttribute('aria-pressed','true');status.hidden=true;},options);
video.addEventListener('pause',()=>{button.hidden=false;button.setAttribute('aria-pressed','false');},options);
video.addEventListener('error',()=>{reset(card);status.hidden=false;},options);
}
status.hidden=true;
try{await video.play();}catch(error){reset(card);status.hidden=false;}
},options);
if('IntersectionObserver' in window){
this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)reset(entry.target);}),{threshold:.15});
cards.forEach(card=>this.observer.observe(card));
}
document.addEventListener('visibilitychange',()=>{if(document.hidden)this.resetAll();},options);
window.addEventListener('pagehide',this.resetAll,options);
}
disconnectedCallback(){this.resetAll?.();this.controller?.abort();this.controller=null;this.observer?.disconnect();}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alisened-storage-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alisened-storage-carousel')) {
    customElements.define('alisened-storage-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const track = this.querySelector('.alsc__track');
        const buttons = [...this.querySelectorAll('[data-alsc-direction]')];
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          buttons.forEach(button => { button.disabled = Number(button.dataset.alscDirection) < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2; });
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const card = track.querySelector('.alsc__item');
          if (!card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
          track.scrollBy({ left: step * Number(button.dataset.alscDirection), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }));
        track.addEventListener('scroll', update, { passive:true });
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() { this.observer?.disconnect(); this.ready = false; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-room-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('room-carousel')) {
    customElements.define('room-carousel', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        if (!this.tabs.length) return;
        this.index = 0;
        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = Number(this.dataset.interval) || 5000;
        this.querySelector('[data-room-previous]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-room-next]')?.addEventListener('click', () => this.show(this.index + 1));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.show(index));
          tab.addEventListener('keydown', event => this.onKeydown(event, index));
        });
        this.addEventListener('pointerdown', event => {
          this.pointerStart = event.clientX;
        });
        this.addEventListener('pointerup', event => {
          if (this.pointerStart === undefined) return;
          const distance = event.clientX - this.pointerStart;
          this.pointerStart = undefined;
          if (Math.abs(distance) < 50) return;
          this.show(this.index + (distance < 0 ? 1 : -1));
        });
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.blockSelectHandler = event => {
          const panel = event.target.closest('[data-room-index]');
          if (panel && this.contains(panel)) this.show(Number(panel.dataset.roomIndex), false);
        };
        document.addEventListener('shopify:block:select', this.blockSelectHandler);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('shopify:block:select', this.blockSelectHandler);
      }

      show(nextIndex, restart = true) {
        if (!this.tabs.length) return;
        this.index = (nextIndex + this.tabs.length) % this.tabs.length;
        this.tabs.forEach((tab, index) => {
          const active = index === this.index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel, index) => {
          panel.hidden = index !== this.index;
          panel.classList.toggle('is-active', index === this.index);
        });
        this.tabs[this.index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        if (restart) {
          this.stop();
          this.start();
        }
      }

      onKeydown(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = index - 1;
        if (event.key === 'ArrowRight') nextIndex = index + 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        this.show(nextIndex);
        this.tabs[this.index].focus();
      }

      start() {
        this.stop();
        if (!this.autoplay || this.tabs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = window.setInterval(() => this.show(this.index + 1, false), this.interval);
      }

      stop() {
        window.clearInterval(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
